import auth from "./auth";
import base from "./base";
import boardActivity from "./boardActivity";
import boardEvent from "./boardEvent";
import boardNews from "./boardNews";
import boardSuggest from "./boardSuggest";
import boardAction from "./boardAction";
import boardActionComment from "./boardActionComment";
import faq from "./faq";
import mypage from "./mypage";
import report from "./report";
import category from "./category";
import campainEvent from "./campainEvent";
import archive from "./archive";

export default {
    auth,
    base,
    boardActivity,
    boardEvent,
    boardNews,
    archive,
    boardSuggest,
    faq,
    mypage,
    report,
    category,
    boardAction,
    boardActionComment,
    campainEvent,
};
